export default function Error404(){
    return (<>Page not found</>)
}